import { useCallback, useEffect, useMemo, useState } from 'react';
import { sortBy } from 'lodash';
import type { Historico } from '../../../services/historicos';
import { HistoricosService, PropriedadesService } from '../../../services';
import useAsyncFetch from '../../../hooks/use-async';

const usePropriedadeSelect = () => {
  const [search, setSearch] = useState('');
  const [historicos, setHistoricos] = useState<Historico[]>([]);

  const { data, loading } = useAsyncFetch(
    {
      callback: async () => {
        const [propriedades, historicosData] = await Promise.all([
          PropriedadesService.list(),
          HistoricosService.all().catch((err) => {
            console.error('[historicos] falha ao carregar:', err);
            return [] as Historico[];
          }),
        ]);
        return { propriedades, historicos: historicosData };
      },
      errorMessage: 'Falha ao buscar propriedades.',
    },
    [],
  );

  const hasError = !loading && !data;

  useEffect(() => {
    if (data?.historicos) setHistoricos(data.historicos);
  }, [data]);

  const markAsRead = useCallback(
    (propriedadeId: number) =>
      setHistoricos((prev) =>
        prev.map((historico) =>
          historico.propriedade === propriedadeId
            ? { ...historico, naoLidas: 0 }
            : historico,
        ),
      ),
    [],
  );

  const propriedadesWithMapUrl = useMemo(
    () => (data?.propriedades ?? []).filter(({ mapaUrl }) => !!mapaUrl),
    [data],
  );

  const filteredPropriedades = useMemo(
    () =>
      sortBy(
        propriedadesWithMapUrl.filter(({ descricao }) =>
          RegExp(search, 'gi').test(descricao),
        ),
        'descricao',
      ),
    [propriedadesWithMapUrl, search],
  );

  return {
    search,
    setSearch,
    loading,
    hasError,
    historicos,
    markAsRead,
    filteredPropriedades,
  };
};

export default usePropriedadeSelect;
